// Loaded once by the global script entry point, including message-only Pantry PDPs.
class ThinSlimVariantNutrition extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;

    if (this.dataset.mode === 'compact') {
      this.cardRoot = this.closest('product-card, article.tsf-product-card');
      this.cardRoot?.addEventListener('change', this.handleCardChange, { signal });
      return;
    }

    this.eventTarget = this.closest('.shopify-section, dialog');
    this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  handleCardChange = (event) => {
    const select = event.target instanceof Element ? event.target.closest('[data-card-purchase-variant]') : null;
    if (!(select instanceof HTMLSelectElement) || !this.cardRoot?.contains(select)) return;
    this.showVariant(select.value);
  };

  showVariant(variantId) {
    const template = Array.from(this.querySelectorAll('template[data-nutrition-variant-id]')).find(
      (candidate) => candidate.dataset.nutritionVariantId === String(variantId),
    );
    const container = this.parentElement;
    if (!container) return;
    container.querySelectorAll(':scope > [data-current-nutrition]').forEach((node) => node.remove());
    container.insertBefore(template ? template.content.cloneNode(true) : document.createDocumentFragment(), this);
    this.dataset.variantId = String(variantId);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = (this.variantRequest || 0) + 1;
    this.variantRequest = request;

    event.promise
      ?.then(({ detail }) => {
        if (!this.isConnected || request !== this.variantRequest || !detail?.html) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;

        const replacement = Array.from(detail.html.querySelectorAll('thinslim-variant-nutrition[data-mode="pdp"]')).find(
          (candidate) => candidate.dataset.nutritionKey === this.dataset.nutritionKey,
        );
        const content = this.querySelector('[data-nutrition-content]');
        const replacementContent = replacement?.querySelector('[data-nutrition-content]');
        if (!content) return;

        const replacementNodes = replacementContent
          ? Array.from(replacementContent.childNodes, (node) => node.cloneNode(true))
          : [];
        content.replaceChildren(...replacementNodes);
        this.dataset.variantId = replacement?.dataset.variantId || String(detail.resource?.id || '');
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-nutrition] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('thinslim-variant-nutrition')) {
  customElements.define('thinslim-variant-nutrition', ThinSlimVariantNutrition);
}
